import React, { useState } from 'react'
import './advanceFilter.css'
import { MenuItem, Menu } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useTranslation } from "react-i18next"
import { M_Select, M_InputTextField, M_CheckBox, M_Button } from '../../../M_Components'

export function AdvanceFilter({ metaPair, metaType, onAddMetaPair,
    onSubmitFilters, onDeleteFilter, onDeleteAllFilters, anchorAF,
    setAnchorAF, onSaveFilter, views, onToasts, color, colorOptions }) {
    const { t } = useTranslation()
    const [showInput, setShowInput] = useState(false)
    const [newView, setNewView] = useState('')
    const [selectedValue, setSelectedValue] = useState('')
    const [openSave, setOpenSave] = useState(false)
    const openAdvancedFilterMenu = Boolean(anchorAF)
    const [open, setOpen] = useState(false)

    const Status = [
        { name: "Waiting For Approval", value: "Waiting For Approval", severity: '#ffb22e', },
        { name: "Waiting For Approval (Changes)", value: "Waiting For Approval (Changes)", severity: '#ff9130', },
        { name: "Waiting For Approval (Cancel)", value: "Waiting For Approval (Cancel)", severity: '#ba002b', },
        { name: "Approved", value: "Approved", severity: '#00b837', },
        { name: "Rejected", value: "Rejected", severity: '#ff0019', },
        { name: "Draft", value: "Draft", severity: '#3a71fc', },
    ]

    const getSeverity = (status) => {
        switch (status) {
            case 'Rejected':
                return '#ff0019';

            case 'Waiting for Approval (Cancel)':
                return '#ba002b';

            case 'Approved':
                return '#00b837';

            case 'Waiting for Approval':
                return '#ffb22e';

            case 'Waiting for Approval (Changes)':
                return '#ff9130';

            case 'Draft':
                return '#3a71fc';
        }
    }

    const addFilter = (name, display, type, operation, value) => {
        const filter = {
            name: name,
            display: display,
            type: type,
            operation: operation,
            value: value
        }
        onAddMetaPair(filter)
    }

    const checkUncheck = (name, type, display) => {
        if (!name) return
        let tempBool = false
        if (metaPair.length) {
            metaPair.forEach(element => {
                if (element.name === name) {
                    tempBool = true
                }
            })
            tempBool ? deleteFilter(name) : type === 'boolean' ? addFilter(name, display, type, 'Equals', false) : type === 'int32' ?  addFilter(name, display, type, 'Equals', '') : colorOptions?.get(name) || name.includes('Status') ? addFilter(name, display, type, 'Equals', '') : addFilter(name, display, type, 'Contains', '')
        } else {
            type === 'boolean' ? addFilter(name, display, type, 'Equals', false) :  type === 'int32' ? addFilter(name, display, type, 'Equals', '')  : colorOptions?.get(name) || name.includes('Status') ? addFilter(name, display, type, 'Equals', '') : addFilter(name, display, type, 'Contains', '')
        }
    }

    const deleteFilter = (filterName) => {
        onDeleteFilter(filterName)
        onToasts('success', '', t("FilterDeleted"))
    }

    const deleteAllFilters = () => {
        onDeleteAllFilters()
        setOpenSave(false)
        setShowInput(false)
        onToasts('success', '', t("ClearedFilters"))
        handleCloseAdvancedFilterMenu()
    }

    const submitFilters = () => {
        onSubmitFilters()
        onToasts('success', '', t("FilterCreated"))
        handleCloseAdvancedFilterMenu()
    }

    const saveFilters = () => {
        if (showInput && newView !== '') {
            onSaveFilter(newView)
            setOpenSave(false)
            setShowInput(false)
            onToasts('success', '', `${newView} ${t("ViewCreated")}`)
        } else {
            if (selectedValue !== 'Create New' && selectedValue !== '') {
                onSaveFilter(selectedValue)
                onToasts('success', '', `${selectedValue} ${t("ViewEdited")}`)
            }
            else {
                onToasts('error', '', `${t("ViewNameError")}`)
            }
        }
    }

    const selectedColumns = () => {
        const aux = []
        metaPair.forEach(element => {
            aux.push(element.name)
        })
        return aux
    }

    const handleCloseAdvancedFilterMenu = () => {
        setAnchorAF(null)
    }

    const optionsMetaType = () => {
        const tempArray = []
        metaType.forEach(element => {
            if ((element.metaType === "string" || element.metaType === "int32" || element.metaType === "boolean") && !element.metaIsList) {
                tempArray.push({ label: element.metaDisplay, value: element.metaName, metaName: element.metaName, metaType: element.metaType, metaDisplay: element.metaDisplay })
            }
        })
        return tempArray
    }

    const optionsSelectedValue = () => {
        const tempArray = []

        Object.keys(Object.fromEntries(views)).map(element => {
            tempArray.push({ label: element, value: element })
        })
        tempArray.push({ label: t("CreateNewView"), value: 'Create New' })

        return tempArray
    }

    return (
        <Menu
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            anchorEl={anchorAF}
            open={openAdvancedFilterMenu}
            onClose={handleCloseAdvancedFilterMenu}
            MenuListProps={{ disablePadding: true }}
            className="organizeMenuSearch"
            PaperProps={{ sx: { marginTop: '1px' } }}
            variant={'menu'}
        >
            <div className='stickyTop'>
                {/* <MenuItem className='menuSearchFilters' disableRipple={true} onClick={() => { setOpen(prev => !prev) }} > */}
                <MenuItem className='menuSearchFilters' disableRipple={true}>
                    <M_Select
                        secondColor={"var(--color-black)"}
                        color={color}
                        label={t("SelectedColumns")}
                        multiple
                        value={selectedColumns()}
                        onClick={(element) => { checkUncheck(element.metaName, element.metaType, element.metaDisplay) }}
                        options={optionsMetaType()}
                    />
                </MenuItem>
            </div>
            <div className='Filters'>
                {metaPair.length ? metaPair.map((element, index) => (
                    <MenuItem className='itemContainer' key={index} disableRipple={true}>
                        <h4 style={{ width: '40%' }}>{element.display}</h4>
                        {colorOptions?.get(element.name) || element.name === 'Status' ?
                            <>
                                <div style={{ margin: '5px', width: '30%' }}>
                                    <M_Select
                                        secondColor={"var(--color-black)"}
                                        color={color}
                                        label={t("Filter")}
                                        value={element.operation}
                                        onChange={(e) => addFilter(element.name, element.display, element.type, e.target.value, element.value)}
                                        options={[{ label: t("EqualsTo"), value: 'Equals' }]}
                                    />
                                </div>
                                <div style={{ margin: '5px', width: '30%' }}>
                                    <M_Select
                                        secondColor={"var(--color-black)"}
                                        color={color}
                                        label={t("Value")}
                                        value={element.value}
                                        onChange={(e) => addFilter(element.name, element.display, element.type, element.operation, e.target.value)}
                                        itemTemplate={(elem) => { return (<div style={{ display: 'flex', padding: '0px 5px', fontWeight: 'bolder', color: 'white', borderRadius: '4px', width: '100%', fontSize: '0.7rem', backgroundColor: elem.severity }} >{elem.name}</div>) }}
                                        options={colorOptions?.get(element.name)?.map(elem => {
                                            return { label: elem.name, value: elem.value, severity: elem.severity, name: elem.name }
                                        })}
                                    />
                                </div>
                            </>
                            : element.type === 'string' ?
                                <>
                                    <div style={{ margin: '5px', width: '30%' }}>
                                        <M_Select
                                            secondColor={"var(--color-black)"}
                                            color={color}
                                            label={t("Filter")}
                                            value={element.operation}
                                            onChange={(e) => addFilter(element.name, element.display, element.type, e.target.value, element.value)}
                                            options={[{ label: t("Contains"), value: 'Contains' }, { label: t("EqualsTo"), value: 'Equals' }]}
                                        />
                                    </div>
                                    <div style={{ margin: '5px', width: '30%' }}>
                                        <M_InputTextField
                                            secondColor={"var(--color-black)"}
                                            color={color}
                                            label={`${t('Value')}`}
                                            type={"text"}
                                            onChange={(e) => addFilter(element.name, element.display, element.type, element.operation, e.target.value)}
                                            value={element.value}
                                        />
                                    </div>
                                </>
                                : element.type === 'int32' ?
                                    <>
                                        <div style={{ margin: '5px', width: '30%' }}>
                                            <M_Select
                                                secondColor={"var(--color-black)"}
                                                color={color}
                                                value={element.operation}
                                                label={t("Filter")}
                                                onChange={(e) => addFilter(element.name, element.display, element.type, e.target.value, element.value)}
                                                options={[{ label: t("EqualsTo"), value: 'Equals' }, { label: t("GreaterThan"), value: 'Greater' }, { label: t("LesserThan"), value: 'Lesser' }]}
                                            />
                                        </div>
                                        <div style={{ margin: '5px', width: '30%' }}>
                                            <M_InputTextField
                                                secondColor={"var(--color-black)"}
                                                color={color}
                                                label={`${t('Value')}`}
                                                type={"number"}
                                                value={element.value}
                                                onChange={(e) => addFilter(element.name, element.display, element.type, element.operation, e.target.value)}
                                            />
                                        </div>
                                    </>
                                    : element.type === 'boolean' ?
                                        <>
                                            <div style={{ margin: '5px', width: '30%' }}>
                                                <M_Select
                                                    secondColor={"var(--color-black)"}
                                                    color={color}
                                                    value={element.operation}
                                                    label={t("Filter")}
                                                    onChange={(e) => addFilter(element.name, element.display, element.type, e.target.value, element.value)}
                                                    options={[{ label: t("EqualsTo"), value: 'Equals' }]}
                                                />
                                            </div>
                                            <div style={{ margin: '5px', width: '30%', justifyContent: 'center', display: 'flex' }}>
                                                <M_CheckBox
                                                    checked={element.value || false}
                                                    onChange={(e) => addFilter(element.name, element.display, element.type, element.operation, e.target.checked)}
                                                />
                                            </div>
                                        </>
                                        :
                                        ""
                        }
                        <div className="closeIcon">
                            <M_Button
                                icon={<Close />}
                                onClick={() => deleteFilter(element.name)}
                                hoverEffect
                                none
                                marginNone
                            />
                        </div>
                    </MenuItem>
                )) :
                    <h4 className='spanItems'>{t("NoFilters")}</h4>
                }
            </div>
            <div className='stickyBot'>
                <MenuItem className='menuItemButtons ' disableRipple={true}>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }}>
                        <M_Button
                            icon={<i className="pi pi-sync" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                            normal
                            hoverEffect
                            labelColor={'var(--color-white)'}
                            backgroundColor={'var(--color-red)'}
                            onClick={() => deleteAllFilters()}
                            label={`${t('ClearFilters')}`}
                        />
                        <M_Button
                            icon={<i className="pi pi-check" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                            normal
                            hoverEffect
                            labelColor={'var(--color-white)'}
                            backgroundColor={'var(--color-green)'}
                            onClick={() => submitFilters()}
                            label={`${t('SubmitFilters')}`}
                        />
                        {metaPair.length ?
                            <div id='saveMenu'>
                                <M_Button
                                    icon={<i className="pi pi-plus-circle" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                                    hoverEffect
                                    normal
                                    label={`${t('Add')}`}
                                    labelColor={'var(--color-white)'}
                                    backgroundColor={color}
                                    onClick={() => {
                                        setSelectedValue('')
                                        setShowInput(false)
                                        setOpenSave(!openSave)
                                    }}
                                />
                            </div>
                            : ''
                        }
                    </div>
                </MenuItem>
                {openSave ?
                    <MenuItem className='removeHover menuCreateView' disableRipple={true} >
                        {metaPair.length ?
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: '100%' }}>
                                <div style={{ width: '80%' }}>
                                    <M_Select
                                        secondColor={"var(--color-black)"}
                                        color={color}
                                        label={t('Save')}
                                        value={selectedValue}
                                        options={optionsSelectedValue()}
                                        onClick={(el) => {
                                            if (el.value === 'Create New' || "") {
                                                setSelectedValue('Create New')
                                                setShowInput(true)
                                            } else {
                                                setSelectedValue(el.value)
                                                setShowInput(false)
                                            }
                                        }}
                                    />
                                </div>
                                <M_Button
                                    icon={<i className="pi pi-save" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                                    normal
                                    hoverEffect
                                    label={t('Save')}
                                    backgroundColor={'var(--color-green)'}
                                    onClick={() => saveFilters()}
                                    labelColor={'var(--color-white)'}
                                />
                            </div>
                            : ''
                        }
                    </MenuItem>
                    : ''
                }
                {showInput ?
                    <MenuItem className='removeHover' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} disableRipple={true} >
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', margin: '0px 10px' }}>
                            <M_InputTextField
                                secondColor={"var(--color-black)"}
                                color={color}
                                label={`${t('Name')}`}
                                type={"text"}
                                onChange={(e) => setNewView(e.target.value)}
                            />
                        </div>
                    </MenuItem>
                    : ''
                }
            </div>
        </Menu >
    )
}

